/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
// Module related to serving up avatar images for Units, whether that be composite, group or account
angular.module('bulbApp.avatarImageModule', ['bulbApp.configModule']);
